<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="image"><a id="page_ii"></a><img alt="Image" src="images/f0ii-01.jpg"/></p>
<p class="linespace"> </p>
<p class="para"> </p>
<p class="center-para">Also by Newt Gingrich and William R. Forstchen</p>
<p class="para"> </p>
<p class="center-para"><em>Gettysburg</em></p>
<p class="center-para1"><em>Grant Comes East</em></p>
<p class="center-para1"><em>Never Call Retreat</em></p>
<p class="center-para1"><em>Pearl Harbor</em></p>
<p class="center-para1"><em>Days of Infamy</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?4180e2a3